import HomePageCmsContainer from "../../container/admin/homepage-cms";

const HomePageCms = () => {
    return <HomePageCmsContainer />;
};

export default HomePageCms;